import React, { FunctionComponent, useEffect, useState } from 'react';
import briefcaseSvg from 'assets/icons/briefcase.svg';
import Card from 'components/common/Card';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import Chip, { Color, Size } from 'lib/Chip';
import { getEligibleResellerMediaOwners } from 'modules/api/reseller';

const ResellerEligibleMediaOwners: FunctionComponent = () => {
  const marketId = useSelector((state: RootState) => state.creative.marketId);
  const dealId = useSelector((state: RootState) => state.creative.dealId);
  const [eligibleMediaOwners, setEligibleMediaOwners] = useState<string[]>([]);
  const [isFetchingEligibleMediaOwners, setIsFetchingEligibleMediaOwners] = useState(false);

  useEffect(() => {
    const getMediaOwners = async (): Promise<void> => {
      try {
        setIsFetchingEligibleMediaOwners(true);
        const result = await getEligibleResellerMediaOwners(marketId, {});
        setEligibleMediaOwners(result);
      } catch (error) {
        setEligibleMediaOwners([]);
      } finally {
        setIsFetchingEligibleMediaOwners(false);
      }
    };

    if (marketId) {
      getMediaOwners();
    }
  }, [dealId]);

  return !isFetchingEligibleMediaOwners ? (
    <Card
      icon={briefcaseSvg}
      header="Media owners"
      info="Creative allowed in the following media owners"
      dataTestId="line-mediaOwners"
    >
      {eligibleMediaOwners.length > 0 ? (
        eligibleMediaOwners.map((mediaOwner) => (
          <span className="mr-1" key={mediaOwner}>
            <Chip color={Color.PRIMARY} label={mediaOwner} size={Size.MEDIUM} truncateLabel={false} />
          </span>
        ))
      ) : (
        <div className="text-center py-4 text-neutral-600">No eligible media owners found</div>
      )}
    </Card>
  ) : null;
};

export default ResellerEligibleMediaOwners;
